import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import CreatetableSelect from "react-select/creatable";
import SweetAlert from "sweetalert2";
import {
  getVendorData,
  createVendor,
  createVendorMap,
} from "../../../store/slices/vendorListMappingSlice";
import { getAllPrograms } from "../../../store/slices/programsSlice";
import { getAllServices } from "../../../store/slices/servicesSlice";
import { getAllSubServices } from "../../../store/slices/subServicesSlice";
import { getCategories } from "../../../store/slices/categories";
import { getSubCategories } from "../../../store/slices/subCategorySlice";

const CreateVendorModal = ({ isOpen, toggle, pagination, onSuccess }) => {
  const dispatch = useDispatch();
  const [vendorCreated, setVendorCreated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const client = useSelector((state) => state.clients?.selectedClient?.value);
  const vendors = useSelector(
    (state) => state.vendorListMappingSlice.vendorData,
  );

  // const allServices = useSelector((state) => state.services.allServices || [{ label: "Others", value: 1 }]);
  // const allSubServices = useSelector((state) => state.subServices.allSubServices || [{ label: "Others", value: 1 }]);
  const categories = useSelector(
    (state) =>
      state.categories?.categoriesData || [{ label: "Others", value: 1 }],
  );
  // const plans = [{ label: "Others", value: 1 }]
  const [programsData, setProgramsData] = useState([]);
  const [allServices, setAllServices] = useState([]);
  const [allSubServices, setAllSubServices] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [subCategoriesData, setSubCategoriesData] = useState([]);
  const [formFields, setFormFields] = useState({
    vendor_id: 0,
    plan_id: 0,
    service_id: null,
    sub_service_id: null,
    category_id: null,
    sub_category_id: null,
    service_charges: "",
  });
  const [selectedVendor, setSelectedVendor] = useState(null);

  const {
    register,
    trigger,
    control,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      vendor_id: 0,
      plan_id: 0,
      service_id: null,
      sub_service_id: null,
      category_id: null,
      sub_category_id: null,
      service_charges: "",
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await dispatch(
        createVendorMap({
          ...formFields,
        }),
      );
      console.log(res, "RESSSSS");
      if (res.type === "vendorListMapping/createVendorMap/fulfilled") {
        SweetAlert.fire(
          "Success",
          "Vendor Mapping created successfully!",
          "success",
        );
        setFormFields({
          vendor_id: 0,
          plan_id: 0,
          service_id: 0,
          sub_service_id: null,
          category_id: null,
          sub_category_id: null,
          service_charges: "",
        });
        setSelectedVendor(null);
        setVendorCreated(false);
        if (onSuccess) {
          onSuccess();
        }
        toggle();
      } else {
        SweetAlert.fire("Error", "Failed to create Vendor Mapping.", "error");
      }
    } catch (error) {
      SweetAlert.fire(
        "Error",
        "An error occurred while creating the vendor mapping.",
        "error",
      );
    }
  };
  const getVendorDataFunc = useCallback(
    async (payload) => {
      if (!isLoading) {
        setIsLoading(true);
        try {
          // vendor_list is a shared table across all tenants (no tenant
          // scoping in this fetch previously) - scope to the active tenant
          // so this dropdown doesn't offer/select another tenant's vendors.
          const mergedFilters = [
            ...(Array.isArray(payload?.filters) ? payload.filters : []),
            ...(client ? [{ id: "tenant_slug", value: client }] : []),
          ];
          await dispatch(getVendorData({ ...payload, filters: mergedFilters }));
        } finally {
          setIsLoading(false);
        }
      }
    },
    [isLoading, dispatch, client],
  );

  const getAllData = async () => {
    let data = await dispatch(getAllPrograms());
    // console.log(data.payload, "PROG DATA");
    setProgramsData(
      data?.payload?.map((item) => {
        return { label: item.name, value: item.ID };
      }) || [],
    );

    let data1 = await dispatch(getAllServices());
    // console.log(data.payload, "PROG DATA");
    setAllServices(
      data1?.payload?.map((item) => {
        return { label: item.name, value: item.ID };
      }) || [],
    );

    let data2 = await dispatch(getAllSubServices());
    // console.log(data.payload, "PROG DATA");
    setAllSubServices(
      data2?.payload?.map((item) => {
        return { label: item.name, value: item.ID };
      }) || [],
    );

    let data3 = await dispatch(getCategories());
    // console.log(data3.payload, "PROG DATA");
    // getCategory returns { categories, count }, not a bare array.
    setCategoriesData(
      data3?.payload?.categories?.map((item) => {
        return { label: item.name, value: item.ID };
      }) || [],
    );

    let data4 = await dispatch(getSubCategories());
    // getSubCategory returns { subCategories, count }, not a bare array.
    setSubCategoriesData(
      data4?.payload?.subCategories?.map((item) => {
        return { label: item.name, value: item.ID };
      }) || [],
    );
  };

  useEffect(() => {
    getVendorDataFunc({});
    getAllData();
  }, []);

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} size="xl">
        <ModalHeader>Create Vendor Mapping</ModalHeader>
        <ModalBody>
          <form className="px-2" onSubmit={handleSubmit}>
            <div className="mb-3">
              <Label for="formFields.vendor_id">Vendor<span className="text-danger">*</span></Label>
              <CreatetableSelect
                options={vendors.map((vendor) => ({
                  label: vendor.vendor_name,
                  value: vendor.ID,
                }))}
                required
                value={selectedVendor}
                onChange={(selected) => {
                  if (selected) {
                    setValue("vendor_id", selected.value);
                    setFormFields({ ...formFields, vendor_id: selected.value });
                    setSelectedVendor(selected);
                    setVendorCreated(false);
                  } else {
                    setVendorCreated(false);
                    setValue("vendor_id", "");
                    setFormFields({ ...formFields, vendor_id: "" });
                    setSelectedVendor(null);
                  }
                }}
                onCreateOption={async (inputValue) => {
                  try {
                    const vendor_slug = inputValue
                      .toLowerCase()
                      .replace(/\s+/g, "-");
                    const result = await dispatch(
                      createVendor({
                        vendor_name: inputValue,
                        vendor_slug,
                        tenant_slug: client,
                      }),
                    ).unwrap();
                    console.log("Vendor create result:", result);
                    // createVendors (bulk-insert via createMany) responds with
                    // { added: { count, data }, duplicates: [...] }, not a bare
                    // row with an ID - createMany doesn't return generated IDs at
                    // all, so the actual vendor has to be looked up afterward.
                    const created = result?.added?.count > 0;
                    const alreadyExists = result?.duplicates?.length > 0;

                    if (created || alreadyExists) {
                      const listResult = await dispatch(
                        getVendorData({
                          filters: client
                            ? [{ id: "tenant_slug", value: client }]
                            : [],
                        }),
                      ).unwrap();
                      const match = Array.isArray(listResult)
                        ? listResult.find(
                            (v) =>
                              v.vendor_slug === vendor_slug &&
                              (!client || v.tenant_slug === client),
                          )
                        : null;

                      if (match) {
                        const newVendorId = match.ID || match.id;
                        const newVendorOption = {
                          label: match.vendor_name || inputValue,
                          value: newVendorId,
                        };
                        setValue("vendor_id", newVendorId);
                        setFormFields({ ...formFields, vendor_id: newVendorId });
                        setSelectedVendor(newVendorOption);
                        setVendorCreated(true);
                        SweetAlert.fire(
                          "Success",
                          created
                            ? "Vendor created successfully!"
                            : "Vendor already exists — selected it.",
                          "success",
                        );
                      } else {
                        setVendorCreated(false);
                        SweetAlert.fire(
                          "Error",
                          "Vendor was saved but could not be found in the list. Please refresh.",
                          "error",
                        );
                      }
                    } else {
                      setVendorCreated(false);
                      SweetAlert.fire(
                        "Error",
                        "Vendor creation failed.",
                        "error",
                      );
                    }
                  } catch (err) {
                    console.error("Vendor create error:", err);
                    setVendorCreated(false);
                    SweetAlert.fire(
                      "Error",
                      "Vendor creation failed.",
                      "error",
                    );
                  }
                }}
                isClearable
              />
              {vendorCreated && (
                <div className="text-success mt-1">Vendor created!</div>
              )}
            </div>
            <div className="mb-3">
              <Label for="formFields.service_charges">Service Charges<span className="text-danger">*</span></Label>
              <Input
                type="number"
                placeholder="Enter Service charges"
                id="formFields.service_charges"
                onChange={(event) => {
                  const value = parseInt(event.target.value);
                  setValue("service_charges", value);
                  setFormFields({
                    ...formFields,
                    service_charges: value?.toString(),
                  });
                }}
                required
                value={formFields.service_charges}
                invalid={formFields.service_charges < 0}
              />
            </div>

            {/* Plans Dropdown */}
            <div className="mb-3">
              <Label for="formFields.plan_id">Plan<span className="text-danger">*</span></Label>
              <Input
                id="formFields.plan_id"
                type="select"
                value={formFields.plan_id}
                required
                onChange={(event) => {
                  const value = parseInt(event.target.value);
                  setValue("plan_id", value);
                  setFormFields({ ...formFields, plan_id: value });
                }}
              >
                <option value="">Select Plan</option>
                {programsData.map((plan) => (
                  <option key={plan.value} value={plan.value}>
                    {plan.label}
                  </option>
                ))}
              </Input>
            </div>

            {/* Services Dropdown */}
            {/* {formFields?.plan_id && ( */}
            <div className="mb-3">
              <Label for="formFields.service_id">Service<span className="text-danger">*</span></Label>
              <Input
                disabled={formFields.plan_id === 0}
                id="formFields.service_id"
                type="select"
                value={formFields.service_id}
                required
                onChange={(event) => {
                  const value = parseInt(event.target.value);
                  setValue("service_id", value);
                  setFormFields({ ...formFields, service_id: value });
                }}
              >
                <option value="">Select Service</option>
                {allServices.map((service) => (
                  <option key={service.value} value={service.value}>
                    {service.label}
                  </option>
                ))}
              </Input>
            </div>
            {/* )} */}

            {/* Subservices Dropdown */}
            {/* {formFields?.service_id && ( */}
            <div className="mb-3">
              <Label for="formFields.sub_service_id">Subservice</Label>
              <Input
                disabled={formFields?.service_id === 0}
                id="formFields.sub_service_id"
                type="select"
                value={formFields.sub_service_id}
                onChange={(event) => {
                  const value = parseInt(event.target.value);
                  setValue("sub_service_id", value);
                  setFormFields({ ...formFields, sub_service_id: value });
                }}
              >
                <option value="">Select Subservice</option>
                {allSubServices.map((sub) => (
                  <option key={sub.value} value={sub.value}>
                    {sub.label}
                  </option>
                ))}
              </Input>
            </div>
            {/* )} */}

            {/* {formFields?.sub_service_id && ( */}
            <div className="mb-3">
              <Label for="formFields.category_id">Category</Label>
              <Input
                disabled={formFields?.sub_service_id === 0}
                id="formFields.category_id"
                type="select"
                value={formFields.category_id}
                onChange={(event) => {
                  const value = parseInt(event.target.value);
                  setValue("category_id", value);
                  setFormFields({ ...formFields, category_id: value });
                }}
              >
                <option value="">Select Category</option>
                {categoriesData.map((cat) => (
                  <option key={cat.value} value={cat.value}>
                    {cat.label}
                  </option>
                ))}
              </Input>
            </div>

            <div className="mb-3">
              <Label for="formFields.sub_category_id">Sub Category</Label>
              <Input
                disabled={formFields?.category_id === 0}
                id="formFields.sub_category_id"
                type="select"
                value={formFields.sub_category_id}
                onChange={(event) => {
                  const value = parseInt(event.target.value);
                  setValue("sub_category_id", value);
                  setFormFields({ ...formFields, sub_category_id: value });
                }}
              >
                <option value="">Select Sub Category</option>
                {subCategoriesData.map((cat) => (
                  <option key={cat.value} value={cat.value}>
                    {cat.label}
                  </option>
                ))}
              </Input>
            </div>
            {/* )} */}

            <button
              className="btn btn-primary mt-3"
              type="submit"
              disabled={!(formFields.vendor_id && formFields.plan_id)}
            >
              Submit
            </button>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
};
export default CreateVendorModal;
